<div class="hz-content ud" style="{{style}}">
  <div class="hz-icon-main ud" hz-click="goto($event)">
    <img class="hz-icon" src={{icon}} alt="" />
  </div>
  <div class="hz-title ud">{{title}}</div>
</div>
